module.exports = __webpack_public_path__ + "static/media/PortraitLeaderboard-10216.278b67bd.jpg";